export enum AppEnsightenEventType {
  INITIAL = 'initial',
  RESERVATION_READY = 'retrievedExistingReservation',
  CHECK_AVAILABILITY = 'checkChangedStayAvallability',
  GET_RESERVATION = 'getReservation',
  GET_HOTEL = 'getHotel',
  MODIFY_RESERVATION = 'updateReservation',
  MEMBER_READY = 'retrievedMember',
  PAGE_READY = 'pageView'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/ensighten/app-ensighten-event-type.model.ts